import React, { useEffect, useState } from "react";
import { API_BASE } from "../api/config";
import LocationSelect from "../components/LocationSelect";
import "./FinanceOverviewCards.css";

const SHOPS = [
  "ALL",
  "GMP",
  "OSHT",
  "OSPF",
  "MT",
  "JS",
  "JCHT",
  "JCPF",
  "MDYHT",
  "MDYPF",
];

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

function formatMoney(value) {
  return Number(value || 0).toLocaleString();
}

export default function FinanceOverviewCards() {
  const [shop, setShop] = useState("ALL");
  const [date, setDate] = useState(todayKey());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function loadOverview() {
    try {
      setLoading(true);
      setError("");

      const res = await fetch(
        `${API_BASE}/api/erp/finance-overview?shop=${shop}&date=${date}`,
      );

      const json = await res.json();

      if (!res.ok || json.success === false) {
        throw new Error(json.message || "Failed to load finance overview");
      }

      setData(json);
    } catch (err) {
      setError(err.message || "Finance overview loading failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadOverview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shop, date]);

  const cash = data?.cash || {};
  const cod = data?.cod || {};
  const expense = data?.expense || {};
  const closing = data?.closing || {};

  return (
    <div className="financeOverview">
      <div className="financeOverview__head">
        <div>
          <span>ERP Finance Overview</span>
          <h2>Today Finance Summary</h2>
          <p>Cash flow, COD receivable, expense and daily closing status.</p>
        </div>

        <div className="financeOverview__filters">
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />

          <LocationSelect value={shop} onChange={setShop} mode="shop" includeAll />

          <button onClick={loadOverview} disabled={loading}>
            {loading ? "Loading..." : "Refresh"}
          </button>
        </div>
      </div>

      {error && <div className="financeOverview__error">{error}</div>}

      <div className="financeOverview__cards">
        <a className="financeCard financeCard--in" href="/erp/cash-flow">
          <span>Cash In</span>
          <strong>{formatMoney(cash.cashIn)} Ks</strong>
          <small>Money received today</small>
        </a>

        <a className="financeCard financeCard--out" href="/erp/cash-flow">
          <span>Cash Out</span>
          <strong>{formatMoney(cash.cashOut)} Ks</strong>
          <small>Expense / refund / transfer out</small>
        </a>

        <a className="financeCard financeCard--net" href="/erp/cash-flow">
          <span>Net Cash</span>
          <strong>{formatMoney(cash.netCash)} Ks</strong>
          <small>Cash In - Cash Out</small>
        </a>

        <a className="financeCard financeCard--cod" href="/erp/cash-flow">
          <span>COD Pending</span>
          <strong>{formatMoney(cod.pending)} Ks</strong>
          <small>Royal Express money not received yet</small>
        </a>

        <a className="financeCard financeCard--expense" href="/erp/expense-report">
          <span>Total Expense</span>
          <strong>{formatMoney(expense.total)} Ks</strong>
          <small>{formatMoney(expense.count)} expense entries</small>
        </a>

        <a className="financeCard financeCard--closing" href="/erp/cash-closing">
          <span>Daily Closing</span>
          <strong>
            {formatMoney(closing.balanced)} / {formatMoney(closing.count)}
          </strong>
          <small>
            Balanced: {formatMoney(closing.balanced)} | Difference:{" "}
            {formatMoney(closing.difference)}
          </small>
        </a>
      </div>
    </div>
  );
}



